import { Image, Wand2 } from 'lucide-react';
import { PageHeader, TabPages } from '@/components';
import { useDocumentTitle } from '@/hooks';
import { BannerTemplatesManager, TemplatesAssistant } from '@/modules/templates';

/**
 * A lista pronta que o assistente de configuracoes do salao oferece -
 * categorias e servicos (sem foto, so nome/duracao/preco), e as fotos da
 * pagina do salao (banners e fotos de categoria), editaveis por quem
 * administra o SaaS.
 */
export function SaasTemplatesPage() {
  useDocumentTitle('Assistente de Configuracoes');

  return (
    <div className="space-y-4">
      <PageHeader
        icon={<Wand2 />}
        title="Assistente de Configuracoes"
        description="O que o assistente do salao ja traz pronto: servicos e a pagina do salao."
      />

      <TabPages
        label="Aba do assistente"
        pages={[
          {
            key: 'servicos',
            label: 'Servicos',
            icon: Wand2,
            render: () => <TemplatesAssistant />,
          },
          {
            key: 'landing',
            label: 'Landing Page',
            icon: Image,
            render: () => <BannerTemplatesManager />,
          },
        ]}
      />
    </div>
  );
}
